



































































































































































































import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BTab,
  BTabs,
  BCardText,
  BFormTextarea,
  BFormFile,
  BSpinner,
  BFormGroup,
  VBTooltip
} from "bootstrap-vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { PlanDeveloppement, PlanDeveloppementFichier } from "@/api/models/plansDeveloppement/planDeveloppement";
import CreatePlanDeveloppement from "./CreatePlanDeveloppement.vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import appSettings from "@/appSettings";
import { EnumTenants } from "@/api/models/enums/enumTenants";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BTab,
    BTabs,
    BCardText,
    BFormTextarea,
    BFormFile,
    BSpinner,
    BFormGroup,
    CreatePlanDeveloppement,
    FeatherIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
})
export default class ListPlansDeveloppement extends Vue {
  @Prop({ required: true }) isMyEntreprise!: boolean
  isAddNewPlanDeveloppementSidebarActive = false;

  listPlansDeveloppement: PlanDeveloppement[] = []
  newFiles: { [key: string]: File[] } = {}
  uploadingFiles: { [key: string]: boolean } = {}

  tenantId = appSettings.getTenantId();
  tenants = EnumTenants;

  async created() {
    await this.loadListPlansDeveloppement()
  }

  async loadListPlansDeveloppement() {
    await this.$http.myressif.entreprises
      .getListPlansDeveloppementByEntrepriseId(
        this.$route.params.id
      )
      .then((response: PlanDeveloppement[]) => {
        response
          .forEach((x) => {
            console.log('begin for', x.id)
            console.log(JSON.parse(x.contenu))
          })
        console.log(response)
        this.listPlansDeveloppement = response.map((x: PlanDeveloppement) => {
          const listLibelle = JSON.parse(x.libelle);
          const listContenu = JSON.parse(x.contenu);
          // Group fichiers by index (assuming fichiers are shared at plan level)
          const listFichiers: PlanDeveloppementFichier[][] = listLibelle.map(() => x.fichiers || []);
          return <PlanDeveloppement>{
            ...x,
            listLibelle,
            listContenu,
            listFichiers,
          };
        });
      }
    )
  }

  getFileKey(planId: string, index: number): string {
    return `${planId}_${index}`;
  }

  async uploadFiles(planDeveloppement: PlanDeveloppement, index: number) {
    const key = this.getFileKey(planDeveloppement.id, index);
    const files = this.newFiles[key];
    if (!files || files.length === 0) return;

    this.$set(this.uploadingFiles, key, true);

    await this.$http.myressif.entreprises
      .addPlanDeveloppementFichiers(
        this.$route.params.id,
        planDeveloppement.id,
        index,
        files
      )
      .then(
        async () => {
          successAlert.fire({
            timer: 2500,
            title: "Upload de fichiers",
            text: `${files.length} fichier(s) ajouté(s) avec succès`,
          });
          this.$set(this.newFiles, key, []);
          await this.loadListPlansDeveloppement();
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$set(this.uploadingFiles, key, false);
      });
  }

  async downloadFile(planDeveloppement: PlanDeveloppement, index: number, fichier: PlanDeveloppementFichier) {
    await this.$http.myressif.entreprises
      .downloadPlanDeveloppementFichier(
        this.$route.params.id,
        planDeveloppement.id,
        index,
        fichier.id
      )
      .then(
        async (response: string) => {
          window.open(response);
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
        }
      );
  }

  askDeleteFile(planDeveloppement: PlanDeveloppement, index: number, fichier: PlanDeveloppementFichier) {
    this.$bvModal
      .msgBoxConfirm(`Êtes-vous sûr de vouloir supprimer le fichier "${fichier.nom}" ?`, {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "danger",
        okTitle: "Supprimer",
        cancelTitle: "Annuler",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDeleteFile(planDeveloppement, index, fichier);
        }
      });
  }

  async confirmDeleteFile(planDeveloppement: PlanDeveloppement, index: number, fichier: PlanDeveloppementFichier) {
    await this.$http.myressif.entreprises
      .deletePlanDeveloppementFichier(
        this.$route.params.id,
        planDeveloppement.id,
        index,
        fichier.id
      )
      .then(
        async () => {
          successAlert.fire({
            timer: 2000,
            title: "Suppression d'un fichier",
            text: "Fichier supprimé avec succès",
          });
          await this.loadListPlansDeveloppement();
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      );
  }

  getFileIcon(filename: string): string {
    const extension = filename.split('.').pop()?.toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'FileTextIcon';
      case 'doc':
      case 'docx':
        return 'FileTextIcon';
      case 'xls':
      case 'xlsx':
        return 'GridIcon';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'ImageIcon';
      case 'zip':
      case 'rar':
        return 'ArchiveIcon';
      default:
        return 'FileIcon';
    }
  }

  async update(id: string, index: number, contenu: string) {
    var data = {contenu}
    await this.$http.myressif.entreprises
      .updatePlanDeveloppementEntreprise(this.$route.params.id, id, index, data)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du plan de développement",
            text: "Plan de développement modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loadListPlansDeveloppement();
      });
  }

  askDelete(id: string, index: number) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce plan de développement ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id, index);
        } else {
          return;
        }
      })
  }

  async confirmDelete(id: string, index: number) {
    await this.$http.myressif.entreprises
      .deletePLanDeveloppement(this.$route.params.id, id, index)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un plan de développement",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loadListPlansDeveloppement();
      })
  }
}
